<div class="share-container" (clickOutside)="onClickedOutside()" tooltip="{{(referralCount >= 10 ) ? ('dashboard.share' | translate) : ('dashboard.refer_friend' | translate)}}">
  <span tourAnchor="ut-refer-icon" (click)="onShareClick()">
    <i class="fa fa-share-alt" aria-hidden="true"></i>
  </span>
  <div class="copy-link d-flex" *ngIf="copyLink">
    <input type="text" class="form-control input-copy" id="copyTextInput" readonly value="{{ pageUrl }}" *ngIf="showLink">
    <button type="button" class="btn tr-btn-primary" title="Copy Link" (click)="onLinkCopy()">{{copyBtnText |translate}}</button>
  </div>
</div>
